import * as React from 'react';

import classnames from 'classnames';

import styles from './link-item.module.css';

type Props = {
    isActive: boolean;
    isHovered?: boolean;
    isEmbedded?: boolean;
    isSubmenuItem?: boolean;
    children: React.ReactNode;
};

export function LinkWrapper(props: Props) {
    const linkWrapperStylenames = classnames({
        [styles['link-item']]: true,
        [styles['link-item--active']]: props.isActive,
        [styles['link-item--submenu-item']]: props.isSubmenuItem,
        [styles['link-item--embedded']]: props.isEmbedded,
        [styles['link-item--hovered']]: props.isHovered,
    });

    return <div className={linkWrapperStylenames}>{props.children}</div>;
}
